<template>
  <div class="flex flex-col offer-detail">
    <div
      class="flex w-full min-h-50 max-h-screen/2"
      v-if="news && news.attributes"
    >
      <img class="object-cover w-full h-max" :src="imageUrl" />
    </div>
    <div
      class="min-h-50 px-4 lg:px-8 lg:w-screen-lg max-w-screen-lg mx-auto text-left space-y-6 mt-10"
      v-if="news && news.attributes"
    >
      <p class="title text-np-glimpse text-np-56 lg:text-np-3xl">
        {{ news.attributes.title }}
      </p>
      <content-body :source="news.attributes.body.content" />
    </div>
    <gallery-slide
      v-if="galleries && galleries.length > 0"
      :images="galleries"
      class="my-18 lg:my-20"
    />
    <share-items />
    <special-item
      v-if="news && news.attributes"
      title-list="other news"
      type="whats-new"
      :subType="news.attributes.type.data.id"
      :exclude-id="currentId"
    />
  </div>
</template>

<script>
import { getNewsBySlug } from "@/api/endpoints/news";
import to from "await-to-js";
import SpecialItem from "@/components/SpecialItem.vue";
import ShareItems from "@/components/ShareItems.vue";
import ContentBody from "../../components/ContentBody.vue";
import GallerySlide from "../../components/gallery/GallerySlide.vue";
import { getImageUrl } from "@/utils/imageUtils.js";

export default {
  name: "newsDetail",
  data() {
    return {
      lang: "en",
      news_id: 0,
      news: {},
      galleries: [],
    };
  },
  components: {
    SpecialItem,
    ShareItems,
    ContentBody,
    GallerySlide,
  },
  async mounted() {
    let news_id = this.$route.params.news_id;
    this.news_id = news_id;
    await this.setnewsDetail(this.lang, news_id);
  },
  watch: {
    "$route.params.news_id": {
      handler: async function (news_id) {
        await this.setnewsDetail(this.lang, news_id);
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currentId() {
      return this.news.id;
    },
    imageUrl() {
      return this.news.attributes.image.data.attributes.url;
      // if (this.news.attributes.image.data.attributes.formats) {
      //   if (
      //     this.news.attributes.image.data.attributes.formats.large &&
      //     this.news.attributes.image.data.attributes.formats.large.url
      //   )
      //     return this.news.attributes.image.data.attributes.formats.large.url;
      //   if (
      //     this.news.attributes.image.data.attributes.formats.small &&
      //     this.news.attributes.image.data.attributes.formats.small.url
      //   )
      //     return this.news.attributes.image.data.attributes.formats.small.url;
      //   if (
      //     this.news.attributes.image.data.attributes.formats.thumbnail &&
      //     this.news.attributes.image.data.attributes.formats.thumbnail.url
      //   )
      //     return this.news.attributes.image.data.attributes.formats.thumbnail
      //       .url;
      // }
      // return "";
    },
  },
  methods: {
    async setnewsDetail(lang, newsId) {
      const [err, response] = await to(getNewsBySlug(lang, newsId));

      if (err) {
        return { errorMessage: err?.response?.data?.error || err.message };
      }
      this.news = response.data.data[0];
      if (this.news.attributes.body.images) {
        this.galleries = this.news.attributes.body.images.data.map((img) => {
          return {
            id: img.id,
            image_url: getImageUrl(img),
          };
        });
      } else {
        this.galleries = [];
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Saol Text" !important;
  font-style: normal;
}

.menu {
  font-family: "Saol Text" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  color: #5c623f;
}

#experience-content {
  border-top: 1px solid #cecdc8;
}

.discover-more {
  background: #5c623f;
  color: white;
}

.description {
  font-style: normal;
  font-weight: 300;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
